const { TextGenerator } = require("../formConstantGenerator");

const loginFormConstant = [
    new TextGenerator('email', 'Email', false, {}, 12, 'email'),
    new TextGenerator('password', 'Password', false, {}, 12, 'password'),
]

export default loginFormConstant